
import StyledTreeItemHorizontal from "./StyledTreeItemHorizontal";

const RenderTreeHorizontal = (props) => {
    const {sourceData, childrenKey, rootItem, childItem, parentPath, onDoubleClick} = props;
    return (
        (sourceData[childrenKey] || []).map((item, index) => {
            const path = parentPath ? parentPath + `.children.${index}` : `children.${index}`;
            if(item[childrenKey]){
                return (
                    <StyledTreeItemHorizontal
                        nodeId={path}
                        component={rootItem}
                        doc={item}
                        onDoubleClick={onDoubleClick}
                    >
                        {RenderTreeHorizontal({
                            sourceData: item,
                            childrenKey,
                            rootItem,
                            childItem,
                            parentPath: path,
                            onDoubleClick
                        })}
                    </StyledTreeItemHorizontal>
                )
            }
            return (
                <StyledTreeItemHorizontal
                    nodeId={path}
                    component={childItem}
                    doc={item}
                    onDoubleClick={onDoubleClick}
                />
            )
        })
    )

}
export default RenderTreeHorizontal;
